module.exports = __webpack_public_path__ + "media/images/ios_appstore_en-d0558d91.svg";